import {
  mdiBed, mdiBookAccount, mdiBookCheck, mdiCashRegister, mdiCog, mdiDatabasePlus, mdiFileChart, mdiMonitorDashboard, mdiSale, mdiCalendarMultiple,
} from '@mdi/js'

const baseMenu = [
  {
    title: 'Dashboard',
    icon: mdiMonitorDashboard,
    to: 'dashboard',
  },
  {
    title: 'Reservas',
    icon: mdiBookAccount,
    children: [
      {
        title: 'Reservas',
        to: 'reserve',
      },
      {
        title: 'Reservas de Grupos',
        to: 'group_reserve',
      },
      {
        title: 'Reservas Efetuadas',
        to: 'completed_reserve',
      },
      {
        title: 'Reservas Faturadas',
        to: 'report/billed_reserves',
      },
      {
        title: 'Rel. de Reservas',
        to: 'reserves_today',
      },
    ],
  },
  {
    title: 'Grid de Quartos',
    icon: mdiBed,
    to: 'manager_room',
  },
  {
    title: 'Recepção',
    icon: mdiBookCheck,
    children: [
      {
        title: 'Checkouts',
        to: 'manager_checkouts',
      },
      {
        title: 'Avulsas',
        to: 'manager_outstanding',
      },
      {
        title: 'Mapa de Ocupação',
        to: 'occupation_map',
      },
      {
        title: 'Movimentação de Ocupação',
        to: 'occupancy_movemment',
      },
      {
        title: 'Auditoria',
        to: 'audit',
      },
    ],
  },

  /*
  {
    title: 'Eventos',
    icon: mdiCalendarMultiple,
    children: [
      {
        title: 'Reservas',
        to: 'events/reserves',
      },
    ],
  },
  */
  {
    title: 'Cadastros',
    icon: mdiDatabasePlus,
    children: [
      {
        title: 'Hóspedes',
        to: 'guest',
        dir: 'register.guest',
        action: 'index',
      },
      {
        title: 'Empresas',
        to: 'register/company',
        dir: 'register.company',
        action: 'index',
      },
      {
        title: 'Fornecedores',
        to: 'register/supply',
        dir: 'register.supply',
        action: 'index',
      },
      {
        title: 'Tarifas',
        to: 'register/tariff',
        dir: 'register.tariff',
        action: 'index',
      },
      {
        title: 'Quartos',
        to: 'register/room',
        dir: 'register.room',
        action: 'index',
      },
      {
        title: 'Categorias de Quarto',
        to: 'register/room_category',
        dir: 'register.room_category',
        action: 'index',
      },
      {
        title: 'Produtos',
        to: 'register/product',
        dir: 'register.product',
        action: 'index',
      },
      {
        title: 'Pontos de Venda',
        to: 'register/pdv',
        dir: 'register.pdv',
        action: 'index',
      },
      {
        title: 'Salões',
        to: 'register/common_area',
        dir: 'register.common_area',
        action: 'index',
      },
      {
        title: 'Serviços',
        to: 'register/service',
        dir: 'register.service',
        action: 'index',
      },
      {
        title: 'Pix',
        to: 'register/pix',
        dir: 'register.pix',
        action: 'index',
      },
    ],
  },
  {
    title: 'Caixas',
    icon: mdiCashRegister,
    children: [
      {
        title: 'Lista de Caixas',
        to: 'cash_list',
      },
      {
        title: 'Vendas PDV',
        to: 'cash/vendas_pdv',
      },
    ],
  },
  {
    title: 'Relatórios',
    icon: mdiFileChart,
    children: [
      {
        title: 'RDS',
        to: 'rds',
      },
      {
        title: 'Acomodações',
        children: [
          {
            title: 'Itens Lançados',
            to: 'daily_posted_itens',
          },
          {
            title: 'Diárias Lançadas',
            to: 'daily_posted',
          },
          {
            title: 'Contas Abertas',
            to: 'report/open_account',
          },
          {
            title: 'Adiantamentos',
            to: 'report/advance_payment',
          },
          {
            title: 'Relatório de Quartos ',
            to: 'occupied_room',
          },
        ],
      },
      {
        title: 'Relatório de Ocupação',
        to: 'occupation_report',
      },
      {
        title: 'Relatório de Diária Média',
        to: 'average_rate_report',
      },
      {
        title: 'Vendas',
        children: [
          {
            title: 'Produtos Lançados',
            to: 'report/product_posted',
          },
          {
            title: 'Produtos Vendidos',
            to: 'report/product_sale',
          },
          {
            title: 'Consumo Interno',
            to: 'intern_consumption',
          },
        ],
      },
      {
        title: 'Financeiro',
        children: [
          {
            title: 'Fechamentos',
            to: 'payment_checkout',
          },
          {
            title: 'Pagamentos',
            to: 'payment_report',
          },
          {
            title: 'Descontos/Estornos',
            to: 'discount_report',
          },
          {
            title: 'Prod. Por Empresa',
            to: 'report/production_by_company',
          },
        ],
      },
    ],
  },
  {
    title: 'Sistema',
    icon: mdiCog,
    children: [
      {
        title: 'Auditoria',
        children: [
          {
            title: 'Diárias automáticas',
            to: 'diary_execution',
          },
          {
            title: 'Histórico de Reservas',
            to: 'reserve/logs',
          },
          {
            title: 'Preferências',
            to: 'audit/preferences',
            dir: 'system.audit_preferences',
            action: 'index',
          },
        ],
      },
      {
        title: 'Configuração',
        to: 'config',
        dir: 'system.config',
        action: 'index',
      },
      {
        title: 'Motor de Reservas',
        to: 'booking-engine-config',
        dir: 'system.config',
        action: 'index',
      },
      {
        title: 'Usuários',
        to: 'user',
        dir: 'system.user',
        action: 'index',
      },
      {
        title: 'Perfis',
        to: 'role',
        dir: 'system.role',
        action: 'index',
      },
    ],
  },
]

const cloneMenu = menuList => menuList.map(item => ({
  ...item,
  ...(item.children ? { children: cloneMenu(item.children) } : {}),
}))

const buildPermissionSet = permissions => {
  if (!Array.isArray(permissions) || permissions.length === 0) return null
  const validPermissions = permissions
    .filter(permission => permission?.dir && permission?.action)

  if (!validPermissions.length) return null

  return new Set(
    validPermissions.map(permission => `${permission.dir}:${permission.action}`),
  )
}

const hasPermission = (dir, action, permissionSet) => {
  if (!dir || !action || !permissionSet) return true

  return permissionSet.has(`${dir}:${action}`)
}

const filterMenu = (menuList, permissionSet) => menuList
  .map(item => {
    const newItem = { ...item }
    if (newItem.children) {
      newItem.children = filterMenu(newItem.children, permissionSet)
    }
    if (hasPermission(newItem.dir, newItem.action, permissionSet) || (newItem.children && newItem.children.length > 0)) {
      return newItem
    }

    return null
  })
  .filter(Boolean)

const buildNavMenu = (permissions = []) => {
  const permissionSet = buildPermissionSet(permissions)
  if (!permissionSet) {
    return cloneMenu(baseMenu)
  }

  return filterMenu(baseMenu, permissionSet)
}

export { buildNavMenu }

export default buildNavMenu
